import "./SemPermissao.css";

export default function SemPermissao({ mensagem = "Você não tem permissão para acessar estes dados." }) {
  return (
    <div className="no-access-container">
      <img src="/images/roda_block.png" alt="Acesso bloqueado" className="no-access-img" />
      <p>{mensagem}</p>
    </div>
  );
}
